
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import {
  SKILLED_WORKER_SERVICE_TYPE,
  SKILLED_WORKER_INSIDE_SERVICE_TYPE,
} from "@/constants/services";

const MESSAGES = {
  headlines: {
    skilled_worker: "Congratulations! You've been granted a Skilled Worker visa.",
    sponsor_licence: "Congratulations! You've been granted a Sponsor Licence.",
  },
};

@Component
export default class ApprovedByHO extends Vue {
  get isSWType() {
    return [SKILLED_WORKER_SERVICE_TYPE, SKILLED_WORKER_INSIDE_SERVICE_TYPE].includes(
      SMCases.caseType
    );
  }

  get headlineText() {
    return this.isSWType ? MESSAGES.headlines.skilled_worker : MESSAGES.headlines.sponsor_licence;
  }
}
